import { createMutationHelper } from '@utils/swr'
import { type CampaignPaymentTransactionBelongingToMemberRequest } from '../types/apiRequest'
import { type FortuneApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<FortuneApis['patch']['paymentTransactionBelongingToMember'], never, CampaignPaymentTransactionBelongingToMemberRequest>({
  client: 'fortune',
  key: '/campaigns',
  fetcher: (_url, { arg, client }) => {
    if (!arg.code) {
      return Promise.reject(new Error('Campaign code is required'))
    }
    if (!arg.order_hash) {
      return Promise.reject(new Error('Order hash is required'))
    }
    return client.patch(`/campaigns/${arg.code}/payment_transactions/${arg.order_hash}/member`)
  },
})

export const useApiCampaignPaymentTransactionBelongingToMember = useMutation
